import Icon from '../components/Icon.vue'

Icon.register({
  'band-aid': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M0 160c0-35.3 28.7-64 64-64h96v320h-96c-35.3 0-64-28.7-64-64v-192zM576 96c35.3 0 64 28.7 64 64v192c0 35.3-28.7 64-64 64h-96v-320h96zM192 416v-320h256v320h-256zM368 184c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM368 280c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM272 184c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24zM272 280c-13.3 0-24 10.7-24 24s10.7 24 24 24 24-10.7 24-24-10.7-24-24-24z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/band-aid.js
// module id = 643
// module chunks = 0